import { render, staticRenderFns } from "./WikiProposalsMenu.vue?vue&type=template&id=0b85e37c&"
import script from "./WikiProposalsMenu.vue?vue&type=script&lang=js&"
export * from "./WikiProposalsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports